<template>
    <Mikomi_Cell :CellTitle="CellTitlePrefix + '総益'" :CellValue="`${Profit}`" :CellTextColor="ProfitTextColor" :CellColor="CellColor" />
    <Mikomi_Cell :CellTitle="CellTitlePrefix + '営業利益'" :CellValue="MikomiTypeData.operatingProfit+''" :CellTextColor="OperatingProfitTextColor" :CellColor="CellColor" />
    <Mikomi_Cell :CellTitle="CellTitlePrefix + '営業利益率'" :CellValue="`${MikomiTypeData.sales !== 0 ? ((MikomiTypeData.operatingProfit/MikomiTypeData.sales) * 100).toFixed(1) : 0}%`" :CellTextColor="OperatingProfitRateTextColor" :CellColor="CellColor" />
    <Mikomi_Cell :CellTitle="CellTitlePrefix + '純利益'" :CellValue="MikomiTypeData.netIncome+''" :CellTextColor="NetIncomeTextColor" :CellColor="CellColor" />
    <Mikomi_Cell :CellTitle="CellTitlePrefix + '在庫'" :CellValue="MikomiTypeData.stock+''" :CellTextColor="StockTextColor" :CellColor="CellColor" />
</template>

<script>
import Mikomi_Cell from './Mikomi_Cell.vue';
export default{
    components:{
        Mikomi_Cell
    },
    computed:{
        Profit()
        {
            if (this.MikomiTypeData.profit === null ||
                this.MikomiTypeData.profit === undefined)
            {
                return '';
            }

            return this.MikomiTypeData.profit;
        },
        ProfitTextColor()
        {
            return typeof this.MikomiTypeData.profit === typeof 0 ? this.MikomiTypeData.profit > 0 ? '#000' : '#a00' : '#a00';
        },
        OperatingProfit()
        {
            if (this.MikomiTypeData.operatingProfit === null ||
                this.MikomiTypeData.operatingProfit === undefined &&
                this.MikomiTypeData.grossOperatingProfit === undefined ||
                this.MikomiTypeData.grossOperatingProfit === null)
            {
                return '';
            }

            return this.MikomiTypeData.grossOperatingProfit !== undefined ? this.MikomiTypeData.grossOperatingProfit : this.MikomiTypeData.operatingProfit;
        },
        OperatingProfitTextColor()
        {
            return typeof this.MikomiTypeData.operatingProfit === typeof 0 ? this.MikomiTypeData.operatingProfit >= 0 ? '#000' : '#a00' : '#a00';
        },
        OperatingProfitRate()
        {
            if (this.MikomiTypeData.operatingProfit === null ||
                this.MikomiTypeData.operatingProfit === undefined)
            {
                return '';
            }

            return `${this.MikomiTypeData.sales !== 0 ? ((this.MikomiTypeData.operatingProfit/this.MikomiTypeData.sales) * 100).toFixed(1) : 0}%`;
        },
        OperatingProfitRateTextColor()
        {
            const rate = this.MikomiTypeData.sales !== 0 ? ((this.MikomiTypeData.operatingProfit/this.MikomiTypeData.sales) * 100).toFixed(1) : 0;
            return rate >= 0 ? '#000' : '#a00';
        },
        NetIncome()
        {
            if (this.MikomiTypeData.netIncome === null ||
                this.MikomiTypeData.netIncome === undefined)
            {
                return '';
            }

            return this.MikomiTypeData.netIncome;
        },
        NetIncomeTextColor()
        {
            return this.MikomiTypeData.netIncome >= 0 ? '#000' : '#a00';
        },
        StockTextColor()
        {
            return this.MikomiTypeData.stock >= 0 ? '#000' : '#a00';
        }
    },
    props:{
        MikomiTypeData: Object,
        CellTitlePrefix: String,
        CellColor: String,
    },
    // mounted(){
    //     console.log(`GAME DEV ${this.CellTitlePrefix} check`, this.MikomiTypeData);
    // }
}
</script>